import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';

export default class TimeoutController extends Controller {
  @service declare router: RouterService;

  @action
  navigateToPleaseWait(): void {
    this.router.replaceWith('signup.please-wait');
  }
}
